import * as React from 'react'
import { socialButton } from './social-button.module.css'

const SocialButton = ({color, title, url, image}) => {
    return (
        <a href={url} className={socialButton} style={color}>{image} {title}</a>
    )
}

export default SocialButton